import PhonePreview from './PhonePreview';

export default PhonePreview;
